<template>
  <section class="page-pc">
    <header class="header">
      <!-- <img class="logo" src="../assets/images/logo-small.png" alt> -->
      <section class="name">Cut Cut</section>
      <div class="nav">
        <a class="mail" href="mailto:cutcutcut.service@gmail.com">Contact</a>
        <a class="privacy" target="_blank" href="/privacy.html">Privacy</a>
      </div>
    </header>
    <div class="main">
      <img class="logo" src="../assets/images/logo-large.png" alt>
      <p class="desc">Cut Cut is the best cut out and professional photo editor.</p>
      <div class="downloads">
        <a target="_blank" href="https://apps.apple.com/us/app/cut-cut-pro-cutout-background/id1458580721">
          <img class="appStore" src="../assets/images/app-store.png" alt>
        </a>
        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.xprodev.cutcam">
          <img class="googlePlay" src="../assets/images/google-play.png" alt>
        </a>
        <a>
          <img class="googlePlay" src="../assets/images/huawei-app-gallery.png" alt>
        </a>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'page-pc',
  beforeCreate () {
    const { $isServer } = this
    if ($isServer) return
    // eslint-disable-next-line no-new-func
    const fn = new Function(`(function(doc,win){var docEl=doc.documentElement;var resizeEvt="orientationchange" in window?"orientationchange":"resize";var recalc=function(){var clientWidth=docEl.clientWidth;if(!clientWidth){return}if(clientWidth>=3840 || clientWidth < 1280){docEl.style.fontSize="100px"}else{docEl.style.fontSize=100*(clientWidth/1280)+"px"}};if(!doc.addEventListener){return}win.addEventListener(resizeEvt,recalc,false);recalc()})(document,window);`)
    fn()
  }
}
</script>
<style lang="less">
.container {
  min-width: 1280px;
}
.page-pc {
  min-height: 100%;
  background: url('../assets/images/bg.png') no-repeat;
  background-position: center center;
  background-size: cover;
  padding: 0.1px;
  .header {
    font-size: 0;
    display: flex;
    justify-content: space-around;
    margin-top: 23px;
    .logo {
      width: 86.67px;
    }
    .name {
      font-size: 20px;
      color: #fff;
    }
    .nav {
      .mail,
      .privacy {
        color: #fff;
        font-weight: 500;
        font-size: 14px;
      }
      .mail {
        margin-right: 26.67px;
      }
    }
  }
  .main {
    font-size: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    .logo {
      width: 115px;
      margin-top: 140px;
    }
    .desc {
      max-width: 50%;
      font-size: 24px;
      font-weight: 300;
      color: #fff;
      text-align: center;
      margin-top: 82px;
      line-height: 1.3;
    }
    .downloads {
      margin-top: 52px;
      .appStore,
      .googlePlay {
        width: 135px;
        border-radius: 6px;
      }
      .appStore,.googlePlay {
        margin-right: 26.67px;
      }
    }
  }
}
</style>
